var map = {
	"./Bupa.png": 41,
	"./MedGulf.png": 9023,
	"./aletihad.png": 21947,
	"./alrajhi_takaful.png": 34551,
	"./arabian.png": 89815,
	"./etihad-1.png": 33226,
	"./etihad.png": 50868,
	"./gig.png": 60584,
	"./globmed__al_arabia.png": 69165,
	"./globmed__al_jazeera_takaful.png": 19826,
	"./globmed__amana.png": 70897,
	"./globmed__cnhi.png": 97751,
	"./globmed__salama.png": 11386,
	"./globmed__saudi_enaya.png": 15932,
	"./gulf.png": 84937,
	"./gulf_insurance_group__gig.png": 24383,
	"./gulf_union.png": 25653,
	"./malath.png": 73956,
	"./nextcare__al_sagr.png": 4360,
	"./rajha.png": 54149,
	"./sager.png": 46313,
	"./saico.png": 34164,
	"./tawuniya.png": 64007,
	"./tcs.png": 22682,
	"./tcs__acig.png": 4071,
	"./tcs__al_etihad.png": 47282,
	"./tcs__al_jazeera_takaful.png": 2900,
	"./tcs__al_sagr.png": 70270,
	"./tcs__arabian_shield.png": 66335,
	"./tcs__buruj.png": 15117,
	"./tcs__uca.png": 55998,
	"./tcs__wala.png": 3826,
	"assets/img/insurance/Bupa.png": 41,
	"assets/img/insurance/MedGulf.png": 9023,
	"assets/img/insurance/aletihad.png": 21947,
	"assets/img/insurance/alrajhi_takaful.png": 34551,
	"assets/img/insurance/arabian.png": 89815,
	"assets/img/insurance/etihad-1.png": 33226,
	"assets/img/insurance/etihad.png": 50868,
	"assets/img/insurance/gig.png": 60584,
	"assets/img/insurance/globmed__al_arabia.png": 69165,
	"assets/img/insurance/globmed__al_jazeera_takaful.png": 19826,
	"assets/img/insurance/globmed__amana.png": 70897,
	"assets/img/insurance/globmed__cnhi.png": 97751,
	"assets/img/insurance/globmed__salama.png": 11386,
	"assets/img/insurance/globmed__saudi_enaya.png": 15932,
	"assets/img/insurance/gulf.png": 84937,
	"assets/img/insurance/gulf_insurance_group__gig.png": 24383,
	"assets/img/insurance/gulf_union.png": 25653,
	"assets/img/insurance/malath.png": 73956,
	"assets/img/insurance/nextcare__al_sagr.png": 4360,
	"assets/img/insurance/rajha.png": 54149,
	"assets/img/insurance/sager.png": 46313,
	"assets/img/insurance/saico.png": 34164,
	"assets/img/insurance/tawuniya.png": 64007,
	"assets/img/insurance/tcs.png": 22682,
	"assets/img/insurance/tcs__acig.png": 4071,
	"assets/img/insurance/tcs__al_etihad.png": 47282,
	"assets/img/insurance/tcs__al_jazeera_takaful.png": 2900,
	"assets/img/insurance/tcs__al_sagr.png": 70270,
	"assets/img/insurance/tcs__arabian_shield.png": 66335,
	"assets/img/insurance/tcs__buruj.png": 15117,
	"assets/img/insurance/tcs__uca.png": 55998,
	"assets/img/insurance/tcs__wala.png": 3826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60562;